// Opens the command palette via a Stimulus outlet.
// Used by buttons outside the command palette controller's DOM scope.
//
// Example usage:
// <button data-controller="command-palette-launcher"
//         data-command-palette-launcher-command-palette-outlet="#command-palette"
//         data-action="command-palette-launcher#open">
//   Search...
// </button>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["command-palette"]

  open() {
    this.commandPaletteOutlet.toggle()
  }
}
